module.exports = __webpack_public_path__ + "img/banner-cesfam-mobile.8b5743a8.png";